/**
 * Notification Type Constants
 *
 * Maps to backend enum NotificationType
 * This ensures type safety and makes the codebase more maintainable
 */

export const NOTIFICATION_TYPES = {
  // Chat notifications
  UPCOMING_TEXT_CHAT: 1,
  UPCOMING_VIDEO_CHAT: 2,
  UPCOMING_DEMO_CHAT: 3,
  CONFIRM_CHAT_REQUEST: 10,
  CHAT_CANCELLED: 12,
  CHAT_REQUEST_DECLINED: 13,
  CHAT_REQUEST_ACCEPTED: 14,
  ACCEPT_CHAT_REQUEST: 24,
  UPCOMING_PHONE_CALL: 25,
  UPCOMING_IN_PERSON_CHAT: 26,

  // Questionnaire notifications
  PRODUCT_QUESTIONNAIRE: 4,
  SERVICE_QUESTIONNAIRE: 5,
  QUESTIONNAIRE_RESPONSE: 15,
  FORM_PENDING_ANSWER: 22,

  // Document notifications
  NEW_FILE_UPLOAD: 6,
  SIGNATURE_DOCUMENT_ASSIGNED: 11,

  // Profile notifications
  USER_UPDATED_PROFILE: 7,
  ADMIN_UPDATED_PROFILE: 16,

  // Article notifications
  ARTICLE: 8,

  // Order/Product notifications
  ORDER_STATUS_CHANGE: 9,
  RESUPPLY_REQUEST: 17,
  AUTOFIT_ELIGIBLE: 18,
  AUTOFIT_RESULTS: 19,
  RESUPPLY: 20,
  RECALL_RESULTS: 21,
  APPOINTMENT_CANCELLED: 23,
  AUTOSHIP_ORDER: 27,
  OPT_OUT_AUTOSHIP: 28,
  SKIP_AUTOSHIP_ORDER: 29,

  // MFA notifications
  MFA_VERIFY_CODE: 30,
  MFA_VERIFY_PHONE: 31,
};

/**
 * Maps notification types to their destination routes
 */
export const NOTIFICATION_ROUTES = {
  [NOTIFICATION_TYPES.UPCOMING_TEXT_CHAT]: "/upcoming-chats",
  [NOTIFICATION_TYPES.UPCOMING_VIDEO_CHAT]: "/upcoming-chats",
  [NOTIFICATION_TYPES.UPCOMING_DEMO_CHAT]: "/upcoming-chats",
  [NOTIFICATION_TYPES.CONFIRM_CHAT_REQUEST]: "/upcoming-chats",
  [NOTIFICATION_TYPES.CHAT_CANCELLED]: "/upcoming-chats",

  [NOTIFICATION_TYPES.PRODUCT_QUESTIONNAIRE]: "/questionnaires",
  [NOTIFICATION_TYPES.SERVICE_QUESTIONNAIRE]: "/questionnaires",

  [NOTIFICATION_TYPES.AUTOFIT_ELIGIBLE]: "/products",
  // [NOTIFICATION_TYPES.AUTOFIT_RESULTS]: "/products", // Commented out in original - case 19

  [NOTIFICATION_TYPES.NEW_FILE_UPLOAD]: "/documents",

  [NOTIFICATION_TYPES.USER_UPDATED_PROFILE]: "/profile",
  [NOTIFICATION_TYPES.ADMIN_UPDATED_PROFILE]: "/profile",

  [NOTIFICATION_TYPES.ARTICLE]: "/dashboard",
  [NOTIFICATION_TYPES.ORDER_STATUS_CHANGE]: "/orders",

  [NOTIFICATION_TYPES.SIGNATURE_DOCUMENT_ASSIGNED]: "/signatures",
};
